/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { tgitems } from '@Constants';
import { relativeContextItemsByHitSetKey as relativeContextItemsByHitSetKeySelector } from '@Containers/RelativeContext/RelativeContextSelectors';
import { setDrawingFromResults as setDrawingFromResultsAction } from '@Containers/ResultsFilters/ResultsFiltersComponents/StructureFilter/StructureFilterActions';
import { isLimitDisabled as isLimitDisabledSelector } from '@Pages/Heatmap/selectors';
import {
  limitTo as limitToAction,
  copyStructureToClipboard as copyStructureToClipboardAction,
  copyStructureToQuery as copyStructureToQueryAction,
  showResultsContextForSelection as showResultsContextForSelectionAction,
} from '@Pages/Heatmap/actions';
import TooltipContentOptions from './TooltipContentOptions';
import useStructureData from './hooks/useStructureData';
import useSortByActivity from './hooks/useSortByActivity';

export function TooltipContentOptionsContainer({
  params,
  isRow,
  onClose,
  type,
  data,
  relativeContexts,
  isLimitDisabled,
  limitTo,
  copyStructureToClipboard,
  copyStructureToQuery,
  copyStructureToResultsFilter,
  showResultsContextForSelection,
}) {
  const { isReady, structure } = useStructureData(params, data);
  const { isSortByActivityActive, isAscending, sortByActivity } = useSortByActivity(params, data, isRow);
  const hasTargets = relativeContexts && relativeContexts.getIn([tgitems, 'resultSize']) > 0;

  const onCopyStructureToClipboard = useCallback(() => {
    copyStructureToClipboard(structure);
    onClose();
  }, [structure]);

  const onCopyStructureToQuery = useCallback(() => {
    copyStructureToQuery({ structure, preview: data.path });
    onClose();
  }, [data, structure]);

  const onCopyStructureToFilter = useCallback(() => {
    copyStructureToResultsFilter({ structure, preview: data.path });
    onClose();
  }, [data, structure]);

  return (
    <TooltipContentOptions
      isRow={isRow}
      type={type}
      isReady={isReady}
      hasStructure={!!data.path}
      isSortByActivityActive={isSortByActivityActive}
      isAscending={isAscending}
      sortByActivity={sortByActivity}
      hasTargets={hasTargets}
      isLimitDisabled={isLimitDisabled}
      limitTo={(options) => limitTo(options, params)}
      onCopyStructureToClipboard={onCopyStructureToClipboard}
      onCopyStructureToQuery={onCopyStructureToQuery}
      onCopyStructureToFilter={onCopyStructureToFilter}
      onShowResultsContextForSelection={showResultsContextForSelection}
    />
  );
}

const mapStateToProps = (state, ownProps) => {
  const { params } = ownProps;
  const relativeContexts = relativeContextItemsByHitSetKeySelector(state, params);
  return {
    relativeContexts,
    isLimitDisabled: isLimitDisabledSelector(state),
  };
};

const mapDispatchToProps = {
  limitTo: limitToAction,
  copyStructureToClipboard: copyStructureToClipboardAction,
  copyStructureToQuery: copyStructureToQueryAction,
  copyStructureToResultsFilter: setDrawingFromResultsAction,
  showResultsContextForSelection: showResultsContextForSelectionAction,
};

TooltipContentOptionsContainer.defaultProps = {
  onClose: () => {},
};

TooltipContentOptionsContainer.propTypes = {
  params: PropTypes.object.isRequired,
  isRow: PropTypes.bool,
  onClose: PropTypes.func,
  type: PropTypes.string,
  data: PropTypes.object,
  relativeContexts: PropTypes.instanceOf(Map),
  isLimitDisabled: PropTypes.bool,
  limitTo: PropTypes.func,
  copyStructureToClipboard: PropTypes.func,
  copyStructureToQuery: PropTypes.func,
  copyStructureToResultsFilter: PropTypes.func,
  showResultsContextForSelection: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(TooltipContentOptionsContainer);
